import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const getServicewiseRevenue = async (groupBy) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/revenue-report/servicewise_revenue/?group_by=${groupBy}`,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch servicewise revenue"
    );
  }
};
